import { CheckSquare, MinusSquare } from "lucide-react";

export function SplitIcon({ active }){
  if(active) return <CheckSquare style={{color:"#65CF72"}} />
  if(!active) return <MinusSquare style={{color:"#D22F19"}}/>
}
